/**
 * Opções e regras do formulário do candidato que precisam bater com o perfil do colaborador
 * (o que o candidato responde cai direto no perfil — decisão do RH: zero redigitação).
 * O servidor (functions/src/recruitment/mapeamentoEtapa2.ts) repete as mesmas listas —
 * functions/ não importa de src/.
 */

/** Perfil: `sex` e `children[].sex`. */
export const SEXO_OPCOES = ['Masculino', 'Feminino', 'Outro'] as const;

/** Perfil: `educations[].type`. */
export const ESCOLARIDADE_OPCOES = ['Ensino Médio', 'Graduação', 'Pós-graduação', 'Mestrado', 'Doutorado'] as const;

/** Perfil: `educations[].status` (EDUCATION_STATUS_OPTIONS). Curso vai pra `educations[].course`. */
export const ESCOLARIDADE_STATUS_OPCOES = ['Concluído', 'Em andamento', 'Trancado'] as const;

/** Perfil: `healthInsuranceProvider` (HealthPlanFieldset). */
export const OPERADORAS_PLANO_SAUDE = ['Bradesco', 'Unimed', 'Noterdame', 'Outro'] as const;
export const PLANO_SAUDE_NAO_ADERIR = 'Não pretendo aderir';

/** Todo candidato informa uma conta de outro banco (com ou sem Itaú) — Itaú não entra na lista. */
export const BANCO_ITAU_CODIGO = '341';

/** Curso só faz sentido a partir de Graduação (aceita também as opções antigas, "Ensino
 * Superior ..."). */
export function escolaridadeTemCurso(escolaridade: string | null | undefined): boolean {
  if (!escolaridade) return false;
  return escolaridade !== 'Ensino Médio' && escolaridade !== 'Ensino Fundamental';
}

export interface PartesEndereco {
  enderecoLogradouro?: string | null;
  enderecoNumero?: string | null;
  enderecoBairro?: string | null;
  enderecoCidade?: string | null;
  enderecoUf?: string | null;
  enderecoPais?: string | null;
  enderecoCep?: string | null;
}

/**
 * Padrão pedido pelo RH pro campo "Endereço" do perfil, tudo junto (o complemento vai no
 * campo próprio): "Rua Júlia Lopes de Almeida 15 - Santa Maria, Belo Horizonte - MG, Brasil,
 * 30525-100". Partes vazias são puladas sem deixar separador sobrando.
 */
export function montarEnderecoCompleto(p: PartesEndereco): string {
  const limpo = (v: string | null | undefined) => (v ?? '').trim();
  const ruaNumero = [limpo(p.enderecoLogradouro), limpo(p.enderecoNumero)].filter(Boolean).join(' ');
  const ruaBairro = [ruaNumero, limpo(p.enderecoBairro)].filter(Boolean).join(' - ');
  const cidadeUf = [limpo(p.enderecoCidade), limpo(p.enderecoUf)].filter(Boolean).join(' - ');
  return [ruaBairro, cidadeUf, limpo(p.enderecoPais), limpo(p.enderecoCep)].filter(Boolean).join(', ');
}
